import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "app/components/Loadable";
import OperationalRouteGuard from "app/components/operational-workspace/OperationalRouteGuard";
import LabCatalogC1Layout from "./LabCatalogC1Layout";

const CatalogPilotProvider = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/context/CatalogPilotContext").then((m) => ({
      default: m.CatalogPilotProvider,
    })),
  ),
);

const CatalogOnboardingHomePage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/CatalogOnboardingHomePage").then((m) => ({
      default: m.CatalogOnboardingHomePage,
    })),
  ),
);

const CatalogBrowsePage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/CatalogBrowsePage").then((m) => ({
      default: m.CatalogBrowsePage,
    })),
  ),
);

const CatalogImportPage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/CatalogImportPage").then((m) => ({
      default: m.CatalogImportPage,
    })),
  ),
);

const LegacyCatalogCsvImportPage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/LegacyCatalogCsvImportPage").then((m) => ({
      default: m.LegacyCatalogCsvImportPage,
    })),
  ),
);

const CatalogConflictsPage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/CatalogConflictsPage").then((m) => ({
      default: m.CatalogConflictsPage,
    })),
  ),
);

const CatalogHospitalsPage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/CatalogHospitalsPage").then((m) => ({
      default: m.CatalogHospitalsPage,
    })),
  ),
);

const LabReportPrintSettingsPage = Loadable(
  lazy(() => import("./LabReportPrintSettingsPage")),
);

const CatalogTariffPage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/CatalogTariffPage").then((m) => ({
      default: m.CatalogTariffPage,
    })),
  ),
);

const CatalogAiReviewPage = Loadable(
  lazy(() =>
    import("lab-catalog-shell/modules/lab/catalog/pages/CatalogAiReviewPage").then((m) => ({
      default: m.CatalogAiReviewPage,
    })),
  ),
);

function guardedCatalog(element) {
  return <OperationalRouteGuard>{element}</OperationalRouteGuard>;
}

/** Native lab catalog — C1ListPanel + MUI (OPS-PHASE1-INTEGRATION-001). */
const LabCatalogRoutes = [
  {
    path: "/lab/admin/catalog",
    element: guardedCatalog(<LabCatalogC1Layout pilotProvider={CatalogPilotProvider} />),
    children: [
      { index: true, element: <CatalogOnboardingHomePage /> },
      { path: "enterprise", element: <CatalogBrowsePage /> },
      { path: "browse", element: <Navigate to="../enterprise" replace /> },
      { path: "import", element: <CatalogImportPage /> },
      { path: "import/legacy", element: <LegacyCatalogCsvImportPage /> },
      { path: "conflicts", element: <CatalogConflictsPage /> },
      { path: "hospital", element: <CatalogHospitalsPage /> },
      { path: "print-settings", element: <LabReportPrintSettingsPage /> },
      { path: "hospitals", element: <Navigate to="../hospital" replace /> },
      { path: "tariffs", element: <CatalogTariffPage /> },
      { path: "ai-review", element: <CatalogAiReviewPage /> },
    ],
  },
  {
    path: "/lab/admin/enterprise",
    element: <Navigate to="/lab/admin/catalog/enterprise" replace />,
  },
  {
    path: "/lab/admin/hospital-mappings",
    element: <Navigate to="/lab/admin/catalog/hospital" replace />,
  },
  {
    path: "/setup/lab",
    element: <Navigate to="/lab/admin/catalog" replace />,
  },
];

export default LabCatalogRoutes;
